import './styles.css';
import { renderShell } from './shell.js';
import { hydrateIcons } from './icons.js';
import * as auth from './auth.js';
import * as router from './router.js';
import * as ui from './ui.js';
import * as modal from './modal.js';
import * as ops from './pages/operations.common.js';
import * as dashboard from './pages/dashboard.js';
import * as users from './pages/users.js';
import * as automatic from './pages/automatic.js';
import * as manual from './pages/manual.js';
import * as plant from './pages/plant.js';
import * as exp from './export.js';

// 1. paint the app shell into #root
renderShell();

// 2. expose every handler referenced by inline onclick="" in the templates
Object.assign(window, auth, router, ui, modal, ops, dashboard, users, automatic, manual, plant, exp, { hydrateIcons });

// 3. hydrate the icons in the freshly-rendered shell
hydrateIcons();

// 4. global listeners
document.getElementById('nav')?.addEventListener('click', (e) => {
  const a = e.target.closest('a[data-route]');
  if (a) router.go(a.dataset.route);
});
document.getElementById('p')?.addEventListener('keydown', (e) => { if (e.key === 'Enter') auth.doLogin(); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') modal.closeModal(); });
